import styled from 'styled-components'

export const TerminalBodyWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    background-color: rgba(15, 54, 66, 0.95);
    overflow: auto;
`
